// Shell state schema — all four scope tiers in a single flat object.
//
// Scope cascade (larger scope clears smaller when switching):
//   USER → ORG → ┬── WORKSPACE → PROJECT
//                └── WORKSPACE PROJECT
//
// Switcher functions in shared/functions/switchers/ manage clearing.
// Activity entities (tickets, chats) are NOT stored here — they are
// fetched declaratively via fetch: props and cached by the fetch plugin.
export default {
  // USER scope — logout invalidates
  user: null,
  preferences: {},
  themeMode: 'auto',
  lang: 'en',

  // ORG scope — switchOrg invalidates (cascades to all below)
  // `orgs` is the membership list (from JWT app_metadata.orgs); `org` is
  // the active one. AppWorkspaceSwitcher reads from JWT claims directly;
  // shell-state copies are the canonical "you're signed in to N orgs"
  // surface for everywhere else.
  orgs: [],
  org: null,
  permissions: null,
  orgMembers: null,
  orgRoles: null,
  orgTeams: null,

  // WORKSPACE scope — switchWorkspace invalidates
  // `workspaces` is the membership list (from JWT app_metadata.workspaces);
  // `workspace` is the active one matching `active_workspace_id`.
  workspaces: [],
  workspace: null,
  workspaceMembers: null,
  workspaceIntegrations: null,
  workspaceBilling: null,

  // Org-switcher transient UI flags. Declared explicitly because smbls
  // 3.14 root.update() drops keys not in the schema (treats state as a
  // typed bag). `_wsSwitching` drives AppWorkspaceSwitchOverlay;
  // `_wsMenuOpen` controls the org dropdown's open/close state.
  // `_pendingActiveOrgId` is the optimistic-pick override the org
  // switcher reads so the dropdown reflects the click instantly,
  // without waiting on the server JWT refresh round-trip.
  _wsSwitching: null,
  _wsMenuOpen: false,
  _pendingActiveOrgId: null,
  _loginLoading: false,

  // Workspace-project private data — populated by `loadPrivateData`
  // (workspace-project/functions/loadPrivateData.js) on every sign-in
  // and re-fetched on org-switch. Must be declared here because the
  // smbls 3.14 router mounts pages directly into Slot without
  // instantiating the workspace-project wrapper that previously owned
  // these keys via its `fetch: [...]` transform / per-app state.js.
  peopleAll: [],
  teamsByEmail: {},
  orgMembersByOrgId: {},
  userDocs: null,
  userPrefs: null,
  companySettings: null,
  userGrants: [],
  valuations: [],
  resourceLinks: [],
  intranetEvents: [],
  jwtClaims: null,
  signedIn: false,
  currentUserEmail: '',
  currentUserId: '',
  orgNotifCount: {},

  // PROJECT scope — canvas-internal switchProject invalidates
  project: null,
  projectComponents: null,
  projectPages: null,
  projectState: null,

  // WORKSPACE PROJECT scope — switchWorkspaceProject invalidates
  workspaceProject: null,

  // Navigation
  currentPath: '/',
  currentSearch: '',

  // Unified-shell flag — sub-apps (workspace-project, canvas, …) read this
  // to hide their own IntranetAppHeader / CanvasAppHeader when they're
  // mounted INSIDE the shell, since the shell already renders the global
  // AppHeader. Standalone wrappers (workspace.localhost, canvas.localhost)
  // do not set this flag, so their app-specific headers keep rendering.
  _inShell: true
}
